import React, { useRef } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";

const UpdateMaterialNameModal = ({
  selectedRowsData,
  updateHandleChange,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const updateData = async (e) => {
    e.preventDefault();
    const { id, material_name, unit } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/raw-mat-name/material-name/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        material_name,
        unit,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <div
      className="modal custom-modal fade"
      id="editModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Update Material Name
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Add Company</h4> */}
                  <form className="form-sample" onSubmit={updateData}>
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="material">Material Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="material_name"
                            id="material"
                            placeholder="Material Name"
                            value={selectedRowsData.material_name}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="Unit">Unit</label>
                          <input
                            type="text"
                            className="form-control"
                            name="unit"
                            id="Unit"
                            placeholder="Unit"
                            value={selectedRowsData.unit}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={updateData}
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateMaterialNameModal;
